<template>
  <div>
    <breadcrumbs class="bg-light text-muted"></breadcrumbs>
    <log-list class="p-5"></log-list>
  </div>
</template>

<script>
  import LogList from '@/components/administration/log/common/LogList'
  import Breadcrumbs from '@/components/common/Breadcrumbs'

  export default {
    metaInfo: {
      title: 'Logs'
    },

    components: {
      'breadcrumbs': Breadcrumbs,
      'log-list': LogList
    }
  }
</script>
